import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CustomSelect from '../../shared/CustomSelect';

class UserTeamAccountList extends Component {
  static propTypes = {
    accounts: PropTypes.instanceOf(Array),
    handleAccountChange: PropTypes.func,
    handleAdminAccessChange: PropTypes.func,
    isDisableAdminToogle: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isRoles: PropTypes.bool,
  };
  static defaultProps = {
    accounts: [],
  };
  state = {
    accountOptions: [],
  };

  UNSAFE_componentWillMount() {
    const { accounts } = this.props;
    const accountOptions = [];
    _.map(accounts, account => {
      const isTPP = account.accountType === 'TPP' ? true : false;
      accountOptions.push({
        ...account,
        label: isTPP
          ? account.accountName + ' ' + '(Third Party)'
          : account.accountName,
        value: account.accountId,
      });
    });
    this.setState({ accountOptions });
  }

  handleAccountChange = account => {
    this.props.handleAccountChange(account.accountId,account.publicId);
  };

  render() {
    const { accountOptions } = this.state;
    return (
      <Fragment>
        <div className="user-roles-admin">
          <div className=" user-search--form-dropdown teams-account-dropdown wd65">
            <label className="sr-only" htmlFor="searchAccounts">
              Search by Accounts
            </label>
            <CustomSelect
              options={accountOptions}
              onChange={this.handleAccountChange}
              placeholder="Accounts Associated with team"
              id="searchAccounts"
              name="searchAccounts"
              defaultSelectedItem="0"
            />
          </div>
          {this.props.isRoles && !this.props.isDisableAdminToogle && (
            <div className="wd30">
              <label className="switch">
                <input
                  type="checkbox"
                  id="togBtn"
                  checked={this.props.isAdmin}
                  onClick={() =>
                    this.props.handleAdminAccessChange(this.props.isAdmin)
                  }
                />
                <div className="slider round">
                  <span className="on">YES</span>
                  <span className="off">NO</span>
                </div>
              </label>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default UserTeamAccountList;
